export default "__VITE_ASSET__Dy$usS4m__"